// Base API URL paths
export default {};
let local = "/data/";
let api = 'https://mlrsd3u5ef.execute-api.us-east-1.amazonaws.com/Prod/';

export const LOCAL_URL = local;
export const API_URL = api;